<ul class="payment-steps">
  <li (click)="goToAddress()" [ngClass]="{'active' :  activeStep == 1, 'under-line': activeStep > 1 }">
    1.{{'modeso_shop_checkout_step1' | injectedText | async}}</li>
  <li> > </li>
  <li [ngClass]="{'active':   activeStep == 2 , 'under-line': activeStep > 2 } "> 2.{{'modeso_shop_checkout_step2' | injectedText | async}} </li>
  <li> > </li>
  <li [ngClass]="{'active': activeStep == 3}"> 3.{{'modeso_shop_checkout_step3' | injectedText | async}}</li>
</ul>
